module.exports = __webpack_public_path__ + "img/abs_pack.6e94bf2f.png";